import { combineReducers } from "redux";

import registration from "./registrationReducer"; 
import branding from "./brandingReducer";
import notifications from "./notificationReducer";
import support from "./supportReducer";
import recaptcha from "./recaptchaReducer";
import verification from "./verificationReducer";
import { intlReducer } from "react-intl-redux";

const rootReducer = combineReducers({
  registration,
  branding,
  notifications,
  support,
  recaptcha,
  verification,

  intl: intlReducer
});

export default rootReducer;
